/**
 * app安装状态
 * 每个包名会有全局唯一的一个实例。
 */
var EventEmitter = require('events').EventEmitter;
var ua = require("@tencent/txv.ua")();
//安装状态判断器
var Checkers = {
  qq: require('./checker/qq'),
  wx: require('./checker/wx'),
  mqb: require('./checker/mqqbrowser')
};
/**
 *
 * @nativePkg 包信息
 *
 */
var Native = module.exports = function (nativePkg) {
  var _state = 2;

	/**
	 * native接口实例
	 * 事件
	 * progress
	 *
	 */
  var instance = Object.create(new EventEmitter, {
    package: {
      value: nativePkg
    },
    state: {
      get: function () {
        return _state;
      },
      set: function (s) {

        if (!(s in Native.STATE)) {
          throw new Error("appBannerFactory: illegal state.." + s + "..just choose:" + JSON.stringify(Native.STATE));
        }
        // console.log('set state_change',s)s
        if (s != _state) {
          var os = _state;
          _state = s;
          this.emit('state_change', s, os);
        }
      }
    },
    readyState: {
      value: false,
      writable: true
    },
    //手Q/微信 下载器
    downloader: {
      value: null,
      writable: true
    },
    model: {
      value: {}
    }
  });

  function afterCheck(err, state) {
    instance.readyState = true;
    !err && (instance.state = state);
    instance.emit('ready');
  }

  try {
    // QQ阅读webview太辣鸡，只好固定为未安装
    if (ua.browser.MQQReader) {
      afterCheck(null, 0);
    } else
      // 微信
      if (ua.browser.WeChat) {
        //微信不让它存在无法判断的情况
        // 新api允许
        // instance.state == 2 && (instance.state = 0);

        //判断。
        Checkers.wx(nativePkg, function () {
          afterCheck.apply(this, arguments);

          //callback和sender是为了让app头部有 返回微信 的标志
          instance.model.callback = 'weixin%3A%2F%2F';
          instance.model.sender = 'weixin';
        });
        //构建下载器
        if (ua.os.android) {
          require('./downloader/wx')(instance, function (err, downloader) {
            err && console.error('wxdownloader async err', err);
            err && err.stack && console.error(err.stack);

            instance.downloader = downloader;
          });
        }
      } else
        // 先判断是不是在手机qq下。因为用户安装了手Q浏览器后，在手Q里打开页面，ua会既被识别成手Q也会被识别成QQ浏览器
        if (ua.browser.MQQClient) {
          Checkers.qq(nativePkg, function () {
            afterCheck.apply(this, arguments);
            instance.model.callback = 'mqqapi%3A%2F%2F';
            instance.model.sender = '%E6%89%8B%E6%9C%BAQQ';
          });
          //构建下载器
          if (ua.os.android) {

            require('./downloader/qq')(instance, function (err, downloader) {
              err && console.error('qqdownloader async err:', err);
              err && err.stack && console.error(err.stack);
              instance.downloader = downloader;
            });
          }
        } else
          // QQ浏览器
          if (ua.browser.MQQBrowser) {
            Checkers.mqb(nativePkg, function () {
              afterCheck.apply(this, arguments);
              instance.model.callback = 'mqqbrowser%3A%2F%2F';
              instance.model.sender = 'QQ%E6%B5%8F%E8%A7%88%E5%99%A8';
            });

          } else
            // 在腾讯视频里判断是否安装了速看
						/* if (nativePkg.uaname == 'synopsis' && ua.browser.QQvideo) {

							isInstalledInQQLive({
								pkgName: nativePkg.pkg,
								pkgUrl: nativePkg.pkgurl
							},
								function (res) {
									var _s = (res && res.installed) ? 1 : (ua.os.ios ? 2 : 10)
									afterCheck(null, _s);
								}
							)
						}  */
            // 改为通用逻辑
            if (ua.browser.QQvideo) {
              require('./downloader/txv')(instance, function (downloader) {
                downloader.check(function (isInstalled) {
                  afterCheck(null, isInstalled ? 1 : 0)
                  instance.downloader = downloader;
                })
              })
            } else
              // 在对应app内，自然是识别为已安装啦
              if (ua.browser[nativePkg.uaname]) {
                afterCheck(null, 1);
              } else {
                afterCheck(null, 2);
              }
  } catch (e) {

  }
  return instance;
};

Native.STATE = require('./state.js').native;

// 在腾讯视频App中，判断是否安装了应用
function connectTenvideoJSBridge(callback) {
  try {
    if (top.TenvideoJSBridge) {
      callback(top.TenvideoJSBridge)
    } else {
      document.addEventListener('onTenvideoJSBridgeReady', function () {
        callback(top.TenvideoJSBridge)
      }, false)
    }
  } catch (e) {
    alert(e.message);
  }

}
function isInstalledInQQLive(option, callback) {
  connectTenvideoJSBridge(function (bridge) {
    bridge.invoke("isInstalled", option, function (res) {
      if (typeof res == 'string') {
        var result = JSON.parse(res);
      } else {
        var result = res;
      }
      callback(result.result);
    });
  });
}
